module.exports = __webpack_public_path__ + "static/media/icon_pendente_WHITE.73770b6e.svg";